import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Utilities() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const getLogs = async (params) => {
    const { headers, queryString } = await queryParamsAndHeaders(params);

    return apiCall({
      url: `${backendUrl}/api/log/show?${queryString}`,
      headers,
    });
  };

  return {
    getLogs,
  };
}
